import { required } from 'vuelidate/lib/validators';

const validations = {
  freeShippingOverXAmount: {
    required,
  },
};

export default validations;